import { ExceptionalOpeningHours } from './exceptional-opening-hours';
import { HolidayOpeningHours } from './holiday-opening-hours';
import { TimeInterval } from './time-interval';

export class OpeningHours {
  monday: TimeInterval[];
  tuesday: TimeInterval[];
  wednesday: TimeInterval[];
  thursday: TimeInterval[];
  friday: TimeInterval[];
  saturday: TimeInterval[];
  sunday: TimeInterval[];

  exceptions: ExceptionalOpeningHours[];
  holidays: HolidayOpeningHours[];

  constructor() {
    this.monday = [new TimeInterval()];
    this.tuesday = [new TimeInterval()];
    this.wednesday = [new TimeInterval()];
    this.thursday = [new TimeInterval()];
    this.friday = [new TimeInterval()];
    this.saturday = [new TimeInterval()];
    this.sunday = [new TimeInterval()];
    this.exceptions = [];
    this.holidays = [];
  }

  // TODO: Rewrite this in a cleaner way
  static isValid(value: OpeningHours, validateHolidays = false): boolean {
    const allDays = [
      value.monday,
      value.tuesday,
      value.wednesday,
      value.thursday,
      value.friday,
      value.saturday,
      value.sunday,
    ];
    for (let i = 0; i < allDays.length; i++) {
      const openingHours = allDays[i];
      if (!openingHours) {
        return false;
      }
      for (let j = 0; j < openingHours.length; j++) {
        const timeInterval = openingHours[j];
        if (!TimeInterval.isValid(timeInterval)) {
          return false;
        }
      }
    }
    if (value.exceptions) {
      for (let i = 0; i < value.exceptions.length; i++) {
        const exception = value.exceptions[i];
        if (!exception) {
          return false;
        }
        for (let j = 0; j < exception.openingHours.length; j++) {
          const timeInterval = exception.openingHours[j];
          if (!TimeInterval.isValid(timeInterval)) {
            return false;
          }
        }
      }
    }
    if (validateHolidays && value.holidays) {
      for (let i = 0; i < value.holidays.length; i++) {
        const holiday = value.holidays[i];
        if (!holiday || holiday.openingHours === undefined) {
          return false;
        }
        if (holiday.openingHours === null) {
          // Opening hours set to inherit normal hours
          continue;
        }
        for (let j = 0; j < holiday.openingHours.length; j++) {
          const timeInterval = holiday.openingHours[j];
          if (!TimeInterval.isValid(timeInterval)) {
            return false;
          }
        }
      }
    }
    return true;
  }

  static countOpenHours(openingHours: OpeningHours): number {
    const allDays = [
      openingHours.monday,
      openingHours.tuesday,
      openingHours.wednesday,
      openingHours.thursday,
      openingHours.friday,
      openingHours.saturday,
      openingHours.sunday,
    ];

    let totalMinutes = 0;

    for (let i = 0; i < allDays.length; i++) {
      const openingHours = allDays[i];

      if (!openingHours) {
        continue;
      }

      for (let j = 0; j < openingHours.length; j++) {
        const timeInterval = openingHours[j];
        if (timeInterval === null) {
          // Indicates that opening hours will be inherited
          continue;
        }
        totalMinutes += timeInterval.to - timeInterval.from;
      }
    }

    return totalMinutes / 60;
  }
}
